module.exports = __webpack_public_path__ + "static/media/Fitness-Group-1.977e59ef.png";